import { render, staticRenderFns } from "./Codebox.vue?vue&type=template&id=4be92179&scoped=true&"
import script from "./Codebox.vue?vue&type=script&lang=js&"
export * from "./Codebox.vue?vue&type=script&lang=js&"
import style0 from "./Codebox.vue?vue&type=style&index=0&id=4be92179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be92179",
  null
  
)

export default component.exports